import {RemoveCircleOutlineTwoTone} from '@mui/icons-material';
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { toast } from "react-toastify";

function DeleteSongRecordAction({ item, onUpdate }: any) {
  const [loading, setLoading] = useState(false);

  const { fetchData: fetchDeleteSongData } = useFetch({
      url: `${import.meta.env.VITE_API_URL}/events/music/delete/${item.id}`,
      method: "DELETE",
  });

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this song record permanently?")) return;

    setLoading(true);
    try {
        const response = await fetchDeleteSongData();
        const result = response.data;
        if (!result || !result.success) { throw new Error("Failed to delete song record"); }
        if (onUpdate) {onUpdate({ _deleted: true});}
        // toast.info("Song record deleted successfully!");
        toast.info(
            <>
            Deleted record for Song ID: {item.song_id}<br /><br />
            Removed Song ID, Program, Style, MK#, Description<br />
            </>
        );
    } catch (error) {
        console.error("Error deleting song record:", error);
        toast.warn("Failed to delete song record. Please try again.");
    } finally {
        setLoading(false);
    }
  };

  return (
    <RemoveCircleOutlineTwoTone
      className="music-icon remove"
      onClick={handleDelete}
      titleAccess="Delete Record"
      style={{
        cursor: "pointer",
        opacity: loading ? 0.5 : 1,
        color: loading ? "#ccc" : "#d32f2f",
      }}
    />
  );
}

export default DeleteSongRecordAction;